import styled from '@emotion/styled';
import { Box, Divider, InputLabel } from '@mui/material';
import React, { useState } from 'react';

import { AlertDialog } from '../../../../../components/dialogs';
import { BasicTextField } from '../../../../../components/textFieilds';
import { TEXT_CONTENT } from '../../../../../utils/constants';

export default function SaveAsPrompt({
  isOpen,
  onClose,
  onOk,
}: {
  isOpen: boolean;
  onClose?: () => void;
  onOk?: (v: string) => void;
}) {
  const [fileName, setFileName] = useState('');
  return (
    <AlertDialog
      open={isOpen}
      title="Save As"
      okBtnText="Save"
      cancelBtnText="Cancel"
      fullWidth
      maxWidth="xs"
      desc={
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <Divider sx={{ mx: -3 }} orientation="horizontal" flexItem />
          <StyledFormGroup sx={{ width: '100%' }}>
            <InputLabel htmlFor="fileName">
              {TEXT_CONTENT.VERSION_NAME}
            </InputLabel>
            <BasicTextField
              id="fileName"
              name="fileName"
              required
              onChange={(e) => {
                setFileName(e.target.value);
              }}
              value={fileName}
            />
          </StyledFormGroup>
        </Box>
      }
      onClose={onClose}
      onCancel={onClose}
      onOk={() => {
        onOk?.(fileName?.trim?.());
      }}
    />
  );
}
const StyledFormGroup = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'column',
  marginTop: '1rem',
  '& label': {
    fontSize: '1.12rem',
    fontWeight: 500,
    marginBottom: '0.5rem',
  },
}));
